
import {isBoolean} from 'underscore';

export class EntryPoint {

  /**
   * Should we register this entry point.
   * @returns {Boolean}
   */
  shouldRegister() {
    var shouldReg = true;
    if (this.isRegistered) {
      return false;
    }
    if (this.initializeOnIds) {
      shouldReg = this.checkElementIdsExist(this.initializeOnIds);
    }
    if (shouldReg) {
      shouldReg = this.checkFeatureFlag();
    }
    return shouldReg;
  }

  /**
   * Should we initialize this entry point.
   * @returns {Boolean}
   */
  shouldInitialize() {
    var shouldInit = true;
    if (this.isInitialized) {
      return false;
    }
    if (this.initializeOnIds) {
      shouldInit = this.checkElementIdsExist(this.initializeOnIds);
    }
    if (shouldInit) {
      shouldInit = this.checkFeatureFlag();
    }
    return shouldInit;
  }

  /**
   * Go through each id and return true if any exist in the page
   * or false if none.
   * @param ids {Array} An array of ids eg: ['id', 'id2']
   * @returns {Boolean}
   */
  checkElementIdsExist(ids) {
    if (!isBoolean(this.checkElementIdsExistResult)) {
      this.checkElementIdsExistResult = ids.reduce((allExist, id) => {
        return allExist ? true : !!document.getElementById(id);
      }, false);
    }
    return this.checkElementIdsExistResult;
  }

  /**
   * Checks to see whether a feature flag exists or is off
   * @returns {Boolean}
   */
  checkFeatureFlag() {
    if (this.featureFlag) {
      return this.featureFlagOff ? this.featureFlag.isOff() : this.featureFlag.isEnabled();
    } else {
      return true;
    }
  }

  register() { }

  initialize() { }

}



// WEBPACK FOOTER //
// ./uikit/entryPoints/EntryPoint.js